import { getAgGridOtherAttributeColumns as getSharedColumns } from "../../../../../../components/OtherAttributes/otherAttributeColumns";
import type { IOtherAttributeConfigApi } from "@schemas/otherAttributesSchema";
import type { IssueTableColumnContext } from "./issueTableColumnContext";

export const getAgGridOtherAttributeColumns = (args: {
  columnContext: IssueTableColumnContext;
  isTaskColumns?: boolean;
  otherAttributesConfig: IOtherAttributeConfigApi;
}) =>
  getSharedColumns({
    ...args,
    columnContext: {
      ...args.columnContext,
      handleUpdateField: args.columnContext.handleUpdateIssueField,
    },
  });
